import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import {
  ProposalSummary,
  ProposeInfluencersSearchSchemaType,
  useProposedInfluencersSearch,
  useUserProposalContext
} from '@anytag/shared-organisms';
import { ProposeInfluencersList } from './propose-influencers-list';

export const ProposeInfluencers = () => {
  const { userProposal } = useUserProposalContext();
  const navigate = useNavigate({ from: '/influencers/proposal' });
  const { filter } = useProposedInfluencersSearch();

  useEffect(() => {
    if (userProposal?.jdMode && filter.jdMode !== userProposal.jdMode) {
      navigate({
        search: (prev: ProposeInfluencersSearchSchemaType) => ({
          ...prev,
          filter: { ...(prev.filter || {}), jdMode: userProposal.jdMode }
        }),
        replace: true
      });
    }
  }, [userProposal?.jdMode, filter.jdMode, navigate]);

  return (
    <div className="mt-10">
      <ProposalSummary summary={userProposal?.summary} currency={userProposal?.currency} />
      <ProposeInfluencersList userProposal={userProposal} />
    </div>
  );
};
